<template>
  <el-container class="outside-chain-design">
    <el-header height="45px" class="outside-chain-design-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>表单设计</el-breadcrumb-item>
        <el-breadcrumb-item>{{definition.name }}</el-breadcrumb-item>
        <el-breadcrumb-item>公开发布</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="header-buttons">
        <el-button @click="preview">预览</el-button>
        <el-dropdown split-button type="primary" @click="save(2)">
          <i v-if="hasSaving" class="el-icon-loading"></i>
          保存
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a @click="save(3)">保存并关闭</a></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container class="outside-chain-design-container">
      <!--左边栏-->
      <div class="aside">
        <div class="title">链接设置</div>
        <div class="top">
          <div class="line">
            <div>发布公开链接</div>
            <el-switch v-model="page.enable" active-color="#54ABF1" inactive-color="#C2C3C4"></el-switch>
          </div>
          <div class="hide-content" v-show="page.enable">
            <div class="line">
              <div>选择链接类型</div>
              <el-input class="linkType" :value="page.linkType===0?'测试链接':'正式链接'" disabled></el-input>
            </div>
            <div class="line">
              <div>发布链接</div>
              <div class="qrCode">
                <el-popover
                    popper-class="myPopover"
                    placement="bottom"
                    width="100"
                    trigger="hover">
                    <img class="bigPic" :src="QrCodeUrl" alt="">
                    <div @click="downloadQrcode" class="downloadNow">下载二维码</div>
                    <img class="smallPic" slot="reference" src="./assets/qrCode.png" alt="">
                  </el-popover>
                <span class="cope"
                      v-clipboard:copy="linkUrl"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError">
                  复制链接
                </span>
              </div>
            </div>
            <div class="line">
              <el-input :value="linkUrl" :title="linkUrl" disabled></el-input>
            </div>
            <el-button type="primary" @click="publishDialogVisible = true">发布设置</el-button>
          </div>
        </div>
        <div class="bottom">
          <p>隐藏的字段</p>
          <div class="annotation">点击右侧表单中字段上的隐藏按钮,被隐藏的字段将放置在这里</div>
          <div class="componentList">
            <div v-for="(item,index) in page.leftComponentList" class="item" :key="item.id">
              {{item.name}}
              <i @click="showComponent(item,index)" class="add el-icon-plus"></i>
            </div>
          </div>
        </div>
      </div>
      <!--右边主体内容-->
      <el-main class="right-content">
        <span class="first">
          <div>公开发布</div>
          <div @click="setBackground"><i class="el-icon-picture-outline"></i> 背景设置</div>
        </span>
        <div ref="headerBg"  class="headerBg"></div>
        <rc-form class="rc-form" ref="form"
                 v-if="definition.form"
                 :outSideChainName="page.title"
                 :outSideChainButtonName="page.button"
                 :outSideChainImageUrl="page.logo"
                 :component="definition.form"
                 :isOutsideChain="true"
                 :selectId="selectId"
                 @editOutSideChainName="editName"
                 @editOutSideChainlogo="editLogo"
                 @editOutSideChainButtonName="editButtonName"
                 :nodeIsCountersign="nodeIsCountersign">
        </rc-form>
      </el-main>
    </el-container>
    <!--发布设置弹窗-->
    <el-dialog center
               title="发布设置" :visible.sync="publishDialogVisible" customClass="publishDialog" width=35%
               :append-to-body='true'>
      <div class="publish-content">
        <div class="label">发布公开链接</div>
        <div>
          选择链接类型
          <el-select style='width:193px' v-model="page.linkType" placeholder="请选择">
            <el-option v-for="item in linkOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="linkUrlLine">
          <el-input :value="linkUrl" disabled></el-input>
          <i @click="refresh" title="重新生成链接" class="el-icon-refresh-right"></i>
          <el-popover
            popper-class="myPopover"
            placement="bottom"
            width="100"
            trigger="hover">
            <img class="bigPic" :src="QrCodeUrl" alt="">
            <div @click="downloadQrcode" class="downloadNow">下载二维码</div>
            <img class="smallPic" slot="reference" src="./assets/qrCode.png" alt="">
          </el-popover>
          <div class="cope"
               v-clipboard:copy="linkUrl"
               v-clipboard:success="onCopy"
               v-clipboard:error="onError">复制链接
          </div>
        </div>
        <div class="label">填写次数</div>
        <div>
          <el-radio-group v-model="page.useType">
            <el-radio label="无限制">无限制</el-radio>
            <el-radio label="仅一次">仅一次</el-radio>
            <el-radio label="每天一次">每天一次</el-radio>
          </el-radio-group>
        </div>
        <hr>
        <div class="label">设备信息</div>
        <div class="note">用户填写表单时的IP地址、浏览器、填写设备、操作系统记录到工作表字段中（文本字段）。</div>
        <div class="label">选择记录设备信息的文本字段</div>
        <div class="equipmentInfo">
          <span class="leftText">IP地址</span>
          <el-select clearable v-model="page.ipAddress" placeholder="请选择">
            <el-option v-for="item in equipmentInfoList" :key="item.columnId" :label="item.name"
                       :value="item.columnId"></el-option>
          </el-select>
        </div>
        <div class="equipmentInfo">
          <span class="leftText">浏览器</span>
          <el-select clearable v-model="page.browser" placeholder="请选择">
            <el-option v-for="item in equipmentInfoList" :key="item.columnId" :label="item.name"
                       :value="item.columnId"></el-option>
          </el-select>
        </div>
        <div class="equipmentInfo">
          <span class="leftText">设备</span>
          <el-select clearable v-model="page.equipment" placeholder="请选择">
            <el-option v-for="item in equipmentInfoList" :key="item.columnId" :label="item.name"
                       :value="item.columnId"></el-option>
          </el-select>
        </div>
        <div class="equipmentInfo">
          <span class="leftText">系统</span>
          <el-select clearable v-model="page.system" placeholder="请选择">
            <el-option v-for="item in equipmentInfoList" :key="item.columnId" :label="item.name"
                       :value="item.columnId"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="save(1)">
            <i v-if="hasSaving" class="el-icon-loading"></i>
            保 存</el-button>
          <el-button @click="publishDialogVisible = false">取 消</el-button>
        </span>
    </el-dialog>
    <!--背景设置弹窗-->
    <el-dialog center
               title="背景设置"
               :visible.sync="backgroundDialogVisible"
               customClass="backgroundDialog"
               width=428px
               :append-to-body='true'>
      <div class="background-content">
        <!--主题颜色-->
        <div class="title">主题颜色</div>
        <div class="theme-color">
          <template v-for="(item,index) in themeColorList">
            <div @click="themeColorChange(index)" :style="{backgroundColor:item.color}" :key="index">
              <img v-show="page.background.themeColorIndex===index" src="./assets/gouxuan.png" alt="">
            </div>
          </template>
        </div>
        <!--封面图片-->
        <div class="title">
          封面图片
          <div @click="clearPic" class="clearPic">清除图片</div>
        </div>
        <div class="coverPic">
          <template v-for="(item,index) in coverPicList">
            <img  @click="coverPicChange(index)"  :src= "item.small" :key="index" alt="">
          </template>
        </div>
        <el-upload
          ref="uploadControl"
          name="files"
          :headers="headers"
          action="/shared-api/files/uploadFiles"
          :on-success="updateFile"
          :show-file-list="false">
          <div class="upload"><span>+</span>&nbsp;上传自定义图片</div>
        </el-upload>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import RcForm from '@/components/form/components/form/rc-form.vue'
import Definition from '@/store/form/definition'
import Schema from '@/store/form/schema'
import FormService from '@/store/form/formService'
import Vue from 'vue'
import tokenStorage from '@/plugins/tokenStorage'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
export default {
  name: 'OutsideChainDesign',
  props: ['id', 'formValue', 'nodeIsCountersign'],
  provide: {
    formService: {},
    componentEventBus: new Vue(),
    componentCount: {},
    sortComponent: {}
  },
  data () {
    return {
      coverPicList,
      definition: {},
      schmea: new Schema(),
      headers: {'Authorization': tokenStorage.getToken()},
      page: {
        //  数据标识
        id: '',
        //  发布公开链接开关
        enable: false,
        //  链接的uuid
        link: '',
        //  图片地址
        logo: '',
        //  背景图片
        background: {
          themeColorIndex: '',
          coverPicIndex: '',
          uploadImg: ''
        },
        //  提交按钮名称
        button: '',
        //  外链标题名称
        title: '',
        //  使用次数
        useType: '',
        //  测试的二维码
        testQrCode: '',
        //  正式二维码
        sysQrCode: '',
        //  pc测试url
        pcTestLinkUrl: '',
        //  pc生产url
        pcSysLinkUrl: '',
        //  移动测试url
        mobileTestLinkUrl: '',
        //  移动生产url
        mobileSysLinkUrl: '',
        //  左侧
        leftComponentList: [],
        //   linkType 0测试，1正式
        linkType: '',
        //  ip地址
        ipAddress: '',
        //  浏览器
        browser: '',
        //  设备
        equipment: '',
        //  系统
        system: ''
      },
      selectId: '',
      draggableList: [],
      publishDialogVisible: false,
      backgroundDialogVisible: false,
      linkUrl: '',
      QrCodeUrl: '',
      linkOptions: [
        {
          value: 0,
          label: '测试链接'
        },
        {
          value: 1,
          label: '正式链接'
        }
      ],
      themeColorList: [
        {color: '#E64F27'},
        {color: '#EB933E'},
        {color: '#5263E7'},
        {color: '#687F2A'},
        {color: '#9B7DF0'},
        {color: '#8DD1ED'},
        {color: '#835C52'}],
      //  设备信息储存列表
      equipmentInfoList: [],
      hasSaving: false
    }
  },
  mounted () {
    this._provided.componentEventBus.$on('outSideChainHidden', this.change)
  },
  components: {
    RcForm
  },
  created () {
    this._provided.formService = new FormService()
    //  获取外链的发布设置、获取rc-form的数据
    this.getData()
  },
  methods: {
    getData () {
      Promise.all([this.$axios.get('/form-api/defines/' + this.id), this.$axios.get('/form-api/publicPublish/' + this.id)]).then((result) => {
        let res = result[0]
        let publishData = result[1].data
        //  处理rc-form的数据
        this.definition = new Definition(res.data)
        this.schmea.load(res.data.form.schema)
        this._provided.componentCount = {}
        this._provided.formService.schema = this.schmea
        this._provided.formService.component = this.definition.form
        this._provided.formService.isOutSide = true
        //  处理发布设置的数据
        publishData.title = publishData.title || res.data.name
        publishData.button = publishData.button || '提交'
        publishData.background = publishData.background ? JSON.parse(publishData.background) : {themeColorIndex: '', coverPicIndex: '', uploadImg: ''}
        publishData.leftComponentList = publishData.leftComponentList ? JSON.parse(publishData.leftComponentList) : []
        this.page = publishData
        //  渲染页面
        this.$nextTick(() => {
          this.draggableList = this.$refs.form.getAllVue(1)
            .filter(m => m.initComponent && m.initComponent.componentType === 'rc-draggable')
          this.$refs.form.getAllVue(2).map(item => {
            this.equipmentInfoList.push({ name: item.component ? item.component.name : item.initComponent.name, columnId: item.component ? item.component.archive.columnId : item.initComponent.archive.columnId })
          })
        })
      }).catch(() => {
        this.$message.error('接口请求失败,请重试')
      })
    },
    refresh () {
      this.$confirm('如果您选择生成新链接,则旧链接将不在可用', '确定生成新链接吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        appendToBody: 'true',
        type: 'warning'
      }).then(() => {
        //  刷新二维码，url
        this.$axios.get('/form-api/publicPublish/refreshPublicUrl/' + this.id).then(res => {
          //  重新赋值sysQrCode、testQrCode、link、pcSysLinkUrl、pcTestLinkUrl
          this.page.sysQrCode = res.data.sysQrCode
          this.page.testQrCode = res.data.testQrCode
          this.page.link = res.data.link
          this.page.pcSysLinkUrl = res.data.pcSysLinkUrl
          this.page.pcTestLinkUrl = res.data.pcTestLinkUrl
          this.$nextTick(() => {
            if (this.page.linkType === 0) {
              this.linkUrl = this.page.pcTestLinkUrl
              this.QrCodeUrl = this.page.testQrCode
            } else {
              this.linkUrl = this.page.pcSysLinkUrl
              this.QrCodeUrl = this.page.sysQrCode
            }
          })
        })
      })
    },
    setBackground () {
      this.backgroundDialogVisible = true
    },
    //  右侧显示控件
    showComponent (json, index) {
      let allComponent = this._provided.formService.getComponents()
      let component = allComponent.filter(m => m.id === json.id)[0]
      let draggable = this.draggableList.filter(m => m.initComponent.id === json.parentId)[0]
      component.properties.OCHidden = false
      this.page.leftComponentList.splice(index, 1)
      draggable.$nextTick(() => {
        draggable.$forceUpdate()
      })
    },
    editName (name) {
      this.page.title = name
    },
    editLogo (url) {
      this.page.logo = url
    },
    editButtonName (name) {
      this.page.button = name
    },
    onCopy: function (e) {
      this.$message('链接已复制，ctrl+v 可粘贴到需要的地方')
    },
    onError: function (e) {
      this.$message.error('复制失败请重试')
    },
    themeColorChange (index) {
      let nowIndex = this.page.background.themeColorIndex
      this.page.background.themeColorIndex = nowIndex === index ? '' : index
    },
    coverPicChange (index) {
      this.page.background.coverPicIndex = index
      this.backgroundDialogVisible = false
    },
    clearPic () {
      this.page.background.uploadImg = ''
      this.page.background.coverPicIndex = ''
    },
    updateFile (res) {
      this.page.background.uploadImg = res[0].result.dir
      if (this.page.background.coverPicIndex > 5) {
        this.page.background.coverPicIndex++
      } else {
        this.page.background.coverPicIndex = 6
      }
      this.backgroundDialogVisible = false
    },
    change ({component, parentId}) {
      let json = {id: component.id, name: component.name, parentId: parentId}
      this.page.leftComponentList.push(json)
    },
    downloadQrcode () {
      this.downloadFile('二维码.png', this.QrCodeUrl)
    },
    // 下载
    downloadFile (fileName, content) {
      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(content)
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true)// initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName
      aLink.href = URL.createObjectURL(blob)
      aLink.click()
    },
    // base64转blob
    base64ToBlob (code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length

      let uInt8Array = new Uint8Array(rawLength)

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], {type: contentType})
    },
    preview () {
      //  预览永远只访问测试地址
      window.open(this.page.pcTestLinkUrl)
    },
    save (type) {
      if (this.hasSaving) {
        return
      }
      this.hasSaving = true
      const model = this._provided.formService.build()
      const definition = this.$_.cloneDeep(this.definition)
      definition.form = model
      let page = this.$_.cloneDeep(this.page)
      page.background = page.background ? JSON.stringify(page.background) : ''
      page.leftComponentList = JSON.stringify(page.leftComponentList)
      Promise.all([this.$axios.post('/form-api/defines', definition), this.$axios.post('/form-api/publicPublish', page)]).then(result => {
        this.publishDialogVisible = false
        this.$message('保存成功')
        this.hasSaving = false
        if (type === 3) {
          this.$emit('closeForm')
        }
      }).catch(() => {
        this.hasSaving = false
        this.$message.error('服务器异常,请重试')
      })
    }
  },
  watch: {
    'page.background.themeColorIndex': {
      handler (newVal, oldVal) {
        this.$nextTick(() => {
          if (newVal !== '') {
            this.$refs.headerBg.style.backgroundColor = this.themeColorList[newVal].color
          } else {
            this.$refs.headerBg.style.backgroundColor = '#B5DBFA'
          }
        })
      },
      immediate: true
    },
    'page.background.coverPicIndex': {
      handler (newVal, oldVal) {
        this.$nextTick(() => {
          if (newVal !== '') {
            //  说明用默认图
            if (newVal >= 6) {
              let viewUrl = sessionStorage.getItem('ossDownloadUrl')
              this.$refs.headerBg.style.backgroundImage = 'url(' + viewUrl + this.page.background.uploadImg + ')'
            } else {
              this.$refs.headerBg.style.backgroundImage = 'url(' + this.coverPicList[newVal].big + ')'
            }
          } else {
            this.$refs.headerBg.style.backgroundImage = ''
          }
        })
      },
      immediate: true
    },
    'page.linkType': {
      handler (newVal, oldVal) {
        this.$nextTick(() => {
          if (newVal === 0) {
            this.linkUrl = this.page.pcTestLinkUrl
            this.QrCodeUrl = this.page.testQrCode
          } else {
            this.linkUrl = this.page.pcSysLinkUrl
            this.QrCodeUrl = this.page.sysQrCode
          }
        })
      },
      immediate: true
    }
  }
}
const coverPicList = [
  {small: require('./assets/01.png'), big: require('./assets/bg-01.png')},
  {small: require('./assets/02.png'), big: require('./assets/bg-02.png')},
  {small: require('./assets/03.png'), big: require('./assets/bg-03.png')},
  {small: require('./assets/04.png'), big: require('./assets/bg-04.png')},
  {small: require('./assets/05.png'), big: require('./assets/bg-05.png')},
  {small: require('./assets/06.png'), big: require('./assets/bg-06.png')}
]
</script>

<style lang="scss">
  .publishDialog {
    min-width: 580px;

    .el-dialog__body {
      padding-top: 10px;
    }

    .publish-content {
      > div {
        height: 35px;
      }
      >div:nth-child(2){
        .el-select{
          margin-left: 20px;
        }
      }
      >div:nth-child(3){
        display: flex;
        align-items: center;
      }
      .equipmentInfo{
        margin-bottom: 5px;
      }
      .label {
        margin-top: 10px;
        font-size: 16px;
      }

      .note {
        color: #A0A0A0;
        font-size: 12px;
        height: 20px;
      }

      hr {
        background-color: #E3E4E5;
        margin-top: 10px;
        height: 1px;
        border: none;
      }

      .leftText {
        display: inline-block;
        width: 60px;
      }

      .el-icon-refresh-right {
        font-size: 18px;
        background-color: #f3f3f3;
        border-radius: 2px;
        padding: 2px;
        margin-left: 10px;
      }

      .el-icon-refresh-right:hover {
        color: #54ABF1;
      }
      .linkUrlLine{
        .el-input{
          width: 304px;
          margin-right: 10px;
        }
        img{
          width: 25px;
          height: 24px;
          margin: 0 15px;
          position: relative;
          top: 2px;
        }
      }
    }
    .cope{
      color: #54ABF1;
      cursor: default;
    }
    .cope:active{
      color: #439AE0;
    }
    .smallPic:hover{
      border-radius: 5px;
      border: 1px solid #54ABF1;
    }
  }

  .backgroundDialog {

    .el-dialog__body {
      padding: 0 25px;
    }

    .background-content {
      .title {
        height: 40px;
        line-height: 40px;
        color: #1A1A1A;
        font-size: 14px;
        position: relative;

        .clearPic {
          position: absolute;
          height: 24px;
          line-height: 24px;
          width: 60px;
          top: 5px;
          right: 0;
          background-color: #F3FAFF;
          color: #8DD1ED;
          padding: 0 2px;
          font-size: 12px;
          text-align: center;
          border-radius: 3px;
        }
        .clearPic:active{
          background-color: #e2eAee;
        }
      }

      .theme-color {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        > div {
          width: 40px;
          height: 40px;
          background-color: red;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 18px;
            height: 14px;
          }
        }
      }

      .coverPic{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap:wrap;
        img{
          width: 120px;
          height: 70px;
          margin-bottom: 10px;
        }
      }
    }

    .upload{
      color: #54ABF1;
      font-size: 14px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      height: 26px;
      span{
        line-height: 26px;
        font-size: 20px;
      }
    }
    .upload:active{
      color: #3289d0;
    }
  }
  .outside-chain-design {
    // 禁止选中文字
    -moz-user-select: none;
    -o-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 100%;

    .outside-chain-design-header {
      background: #fff;
      line-height: 45px;
      box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
      padding: 0 12px 0 26px;

      &:after {
        content: "";
        display: block;
        clear: both;
      }

      .el-breadcrumb {
        display: inline-block;
        line-height: 45px;

        span {
          font-weight: 700;
          font-size: 15px;

          &:hover {
            font-weight: 700;
          }
        }

        .name {
          vertical-align: middle;
          margin-left: 10px;
          color: #409EFF;
          cursor: pointer;
        }
      }

      .header-buttons {
        float: right;
        margin-right: 20px;
        > .el-button {
          padding: 7px 0;
          width: 62px;

          &:nth-child(1) {
            margin-right: 20px;
          }
        }

        .el-dropdown .el-button {
          padding: 7px 5px;

          &:nth-child(1) {
            padding: 7px 15px;
          }
        }
      }
    }

    .outside-chain-design-container {
      height: calc(100% - 45px);
      background: #f8fbfe;
      margin-top: 8px;

      .aside {
        width: 242px;
        min-width: 242px;
        float: left;
        height: 100%;
        background: #fff;
        position: relative;
        border: 1px solid #c2c3c4;
        border-radius: 4px;
        margin: 0 8px;
        overflow-y: auto;
        overflow-x: hidden;

        .title {
          overflow: hidden;
          text-align: center;
          line-height: 34px;
          height: 34px;
          width: 240px;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          color: #54ABF1;
          background-color: #EBF6FF;
          font-size: 14px;
          margin-bottom: 10px;
        }

        .top {
          padding: 0 15px 10px;
          border-bottom: 1px solid #dddddd;

          .line {
            height: 35px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;

            div {
              font-size: 12px;
            }

            font-size: 12px;
          }

          .el-button {
            width: 210px;
            margin-top: 13px;
          }
          .hide-content{
            .linkType{
              width: 91px;
              input{
                padding-left: 19px;
              }
            }
            .qrCode{
              display: flex;
              align-items: center;
              height: 35px;
              text-align: center;
              .smallPic{
                width: 25px;
                height: 25px;
                margin-right: 10px;
              }
              .smallPic:hover{
                border-radius: 5px;
                border: 1px solid #54ABF1;
              }
            }
          }
        }

        .bottom {
          padding: 10px 15px;

          .annotation {
            background: rgba(243, 243, 243, 1);
            margin-top: 10px;
            padding: 5px 10px;
            font-size: 12px;
          }

          .componentList {
            width: 100%;

            div {
              background: rgba(243, 243, 243, 1);
              margin-top: 10px;
              padding: 0 10px;
            }

          }

          .item {
            min-height: 30px;
            line-height: 30px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }
      }

      .el-main {
        float: left;
        margin-left: 12px;
        width: calc(100% - 300px);
        height: 100%;
        padding: 16px 28px 0 18px;
        background: #fff;

        .component-title {
          padding-left: 10px;
        }

        .first {
          position: absolute;
          top: 0;
          left: 18px;
          z-index: 1;
          height: 30px;
          margin-left: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: calc(100% - 58px);
          &::before {
            content: "";
            width: 2px;
            height: 14px;
            background: #54abf1;
            position: absolute;
            left: -10px;
            top: 8px;
          }

          div:nth-child(2) {
            color: #54ABF1;
          }

          div:nth-child(2):active{
            color: #439AE0;
          }
        }

        .design-buttons {
          text-align: center;
          margin-top: 40px;
          overflow: auto;
          white-space: nowrap;

          .el-button {
            height: 26px;
            padding: 5px 9px;
          }

          .tooltip {
            color: #b3d8ff;
          }
        }
      }

      .buttons {
        padding-top: 5px;
        padding-left: 20px;
        padding-right: 20px;
      }
    }

    .add:active {
      color: #54ABF1;
    }

    .add:hover {
      color: #54ABF1;
    }

    .layout-form {
      min-height: calc(100% - 200px) !important;
    }

  }
  .myPopover{
    padding: 10px 0!important;
    text-align: center!important;
    .bigPic{
      width: 80%;
      height: auto;
    }
    .downloadNow{
      text-align: center;
      color:#54ABF1;
      cursor: default;
    }
  }
  .downloadNow{
    text-align: center;
    color:#54ABF1;
    cursor: default;
  }
</style>
<style lang="scss" scoped>
  .outside-chain-design {
    .right-content {
      position: relative;
      padding-top: 80px;

      .rc-form {
        border: 1px solid #dddddd;
        width: 90%;
        margin: 0 auto;
        z-index: 2;
        background-color: #ffffff;
        box-sizing: border-box;
        min-height: 100%;
      }

      .headerBg {
        height: calc((100% - 47px)*279/1366);
        width: calc(100% - 47px);
        position: absolute;
        top: 30px;
        left: 18px;
        background-color: #B5DBFA;
        background-repeat:no-repeat;
        background-size: 100% 100%;
        z-index: 1;
      }
    }
    .cope{
      color: #54ABF1;
    }
    .cope:active{
      color: #439AE0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/design/outside-chain-design.vue